module.exports = __webpack_public_path__ + "img/file-magnifying-glass.78622540.svg";